import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonLevels, ButtonSizes } from '@zipari/shared-ds-util-button';
import { LabelsOrNotes } from '../../side-panel.constants';

@Component({
  selector: 'side-panel-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent {
  @Input() showInfo = false;
  @Input() whichInfo: LabelsOrNotes = 'labels';
  @Output() showInfoChange: EventEmitter<boolean> = new EventEmitter();

  doneButtonConfig = {
    level: ButtonLevels.high,
    content: 'Done',
    size: ButtonSizes.fullWidth,
  };

  handleClose() {
    this.showInfo = false;
    this.showInfoChange.emit(false);
  }
}
